<template>
  <div class="img-wrap">
    <decrypt-img :src="src" class="cover" :style="{width: width, height: height}">
      <div slot="placeholder" class="image-slot" :style="{width: width, height: height, lineHeight: height}">
        <i class="el-icon-loading"></i>加载中
      </div>
    </decrypt-img>
    <!--封面图、视频弹窗组件-->
    <media-popup ref="mediaPopup" ></media-popup>
  </div>
</template>
<script>
import MediaPopup from '@/components/media-popup'
export default {
  data() {
    return {

    }
  },
  components: {
    MediaPopup,
  },
  props: ['width', 'height', 'src'],
  // created() {
  //   console.log(this.src)
  // },
  methods: {
    // 查看媒体
    checkMedia(url, type) {
      this.$refs.mediaPopup.open(url, type)
    },
  }
} 
</script>

<style lang="scss">
.img-wrap {
  display: flex;
  justify-content: center;
  cursor: pointer;
  .image-slot {
    background: #f5f7fa;
    font-size: 12px;
    color: #c0c4cc;
  }
  .el-image__error {
    font-size: 12px;
  }
}
</style>